import { create } from 'zustand';
import { ColumnState } from 'ag-grid-community';
import { DateRange } from 'react-day-picker';
import { EQM4010_R01DetailDto, defaultEQM4010_R01DetailDto, EQM4010_R01HeaderDto } from './Dto_EQM4010_R01';
import { showWarning } from 'src/utils/toast/toastUtil';
import { getCurrentMonthDateRange } from 'src/utils/date/dateUtils';

export interface EQM4010_R01Filter {
	compCd: string;
	moldCd: string;
	moldNm: string;
	moldClass: string;
	inquiryDt: DateRange | undefined;
}
export interface Store_EQM4010_R01 {
	// ====== 검색 필터 ======
	EQM4010_R01Filter: EQM4010_R01Filter;
	EQM4010_R01PastFilter: EQM4010_R01Filter;
	setEQM4010_R01Filter: (filter: Partial<EQM4010_R01Filter>) => void;
	setEQM4010_R01PastFilter: (filter: Partial<EQM4010_R01Filter>) => void;

	// ====== 품목 리스트 및 선택 ======
	EQM4010_R01List: EQM4010_R01HeaderDto[]; // 품목 목록 
	setEQM4010_R01List: (itemList: EQM4010_R01HeaderDto[]) => void;

	selectedEQM4010_R01: EQM4010_R01HeaderDto | undefined; // 선택된 품목 
	setSelectedEQM4010_R01: (data: EQM4010_R01HeaderDto | undefined) => void;
	initSelectedEQM4010_R01: () => void;

	// 검색 조건에서 선택된 금형 정보 (모달용)
	selectedMoldInfo: { moldCd: string; moldNm: string } | undefined;
	setSelectedMoldInfo: (moldInfo: { moldCd: string; moldNm: string } | undefined) => void;

	// ====== BOM 리스트 및 선택/편집 ======
	EQM4010_R01DetailList: EQM4010_R01DetailDto[]; // Bom 리스트 
	setEQM4010_R01DetailList: (bomList: EQM4010_R01DetailDto[]) => void;
	insertEQM4010_R01DetailList: (data: EQM4010_R01DetailDto[], index?: number) => void;
	removeEQM4010_R01Detail: (index: number) => void;
	updateEQM4010_R01Detail: (index: number, updatedRow: EQM4010_R01DetailDto) => void;

	selectedEQM4010_R01Detail: EQM4010_R01DetailDto | undefined; // 선택된 BOM 
	setSelectedEQM4010_R01Detail: (data: EQM4010_R01DetailDto | undefined) => void;
	initSelectedEQM4010_R01Detail: () => void;

	// ====== BOM 상세 행 선택/삭제 관리 ======
	deletedEQM4010_R01DetailList: string[]; // 삭제된 BOM 리스트 
	addDeletedEQM4010_R01DetailList: (idList: string[]) => void;
	removeDeletedEQM4010_R01DetailList: (idList?: string[]) => void;
	
	selectedEQM4010_R01DetailList: string[]; // 선택된 BOM 상세 리스트 
	setSelectedEQM4010_R01DetailList: (idList: string[]) => void; // 선택된 BOM 상세 리스트 설정 (EQM4010 전용)
	addSelectedEQM4010_R01DetailList: (idList: string[]) => void; // 선택된 BOM 상세 리스트 추가 
	removeSelectedEQM4010_R01DetailList: (idList?: string[]) => void; // 선택된 BOM 상세 리스트 제거 
	initSelectedEQM4010_R01DetailList: () => void; // 선택된 BOM 상세 리스트 초기화 
	allSelectedEQM4010_R01DetailList: () => void; // 선택된 BOM 상세 리스트 전체 선택 

	// ====== 컬럼 상태(그리드) ======
	columnState: ColumnState[] | null;		setColumnState: (state: ColumnState[] | null) => void;
	detailColumnState: ColumnState[] | null;		setDetailColumnState: (state: ColumnState[] | null) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;
	detailScrollTop: number | null;
	setDetailScrollTop: (top: number | null) => void;

	originalEQM4010_R01DetailList: EQM4010_R01DetailDto[];
	setOriginalEQM4010_R01DetailList: (list: EQM4010_R01DetailDto[]) => void;

	allCount: number;				setAllCount: (allCount: number) => void;
	detailFetchTrigger: boolean;	setDetailFetchTrigger: (trigger: boolean) => void;
	

	// ====== 초기화 ======
	initData: () => void;
}


export interface Store_EQM4010_R01_GridCalendarState {

	// ====== EQM4010_R01 GridCalendar 상태 ======
	EQM4010_R01GridCalendarState: {
		pickerVisible: boolean;
		pickerPosition: { top: number; left: number };
		targetRowIndex: number | null;
		targetField: string | null;
		targetDate: Date | undefined;
	};
	setEQM4010_R01GridCalendarState: (state: Partial<Store_EQM4010_R01_GridCalendarState['EQM4010_R01GridCalendarState']>) => void;
	initEQM4010_R01GridCalendarState: () => void;

}

export const defaultEQM4010_R01Filter : EQM4010_R01Filter = {
	compCd: '',
	moldCd: '',
	moldNm: '',
	moldClass: '',
	inquiryDt: getCurrentMonthDateRange(),
};

export const useEQM4010_R01Store = create<Store_EQM4010_R01>((set) => ({
	// ====== 검색 필터 ======
	EQM4010_R01Filter: defaultEQM4010_R01Filter,
	EQM4010_R01PastFilter: defaultEQM4010_R01Filter,
	setEQM4010_R01Filter: (filter: Partial<EQM4010_R01Filter>) => set((state) => ({
		...state,
		EQM4010_R01Filter: { ...state.EQM4010_R01Filter, ...filter }
	})),
	setEQM4010_R01PastFilter: (filter: Partial<EQM4010_R01Filter>) => set((state) => ({
		...state,
		EQM4010_R01PastFilter: { ...state.EQM4010_R01PastFilter, ...filter }
	})),

	// ====== 품목 리스트 및 선택 ======
	EQM4010_R01List: [],
	setEQM4010_R01List: (itemList: EQM4010_R01HeaderDto[]) => set((state) => ({
		...state,
		EQM4010_R01List: itemList
	})),

	selectedEQM4010_R01: undefined,
	// 품목 변경 시 BOM 관련 상태 초기화
	setSelectedEQM4010_R01: (data) => set((state) => {
		return { 
			selectedEQM4010_R01: data,
			// 품목 변경 시 BOM 관련 상태 초기화
			EQM4010_R01DetailList: [],
			selectedEQM4010_R01Detail: undefined,
			editEQM4010_R01Detail: null,
			deletedEQM4010_R01DetailList: [],
			selectedEQM4010_R01DetailList: [],
			detailFetchTrigger: true
		};
	}),
	initSelectedEQM4010_R01: () => set({ selectedEQM4010_R01: undefined, EQM4010_R01DetailList: [], detailFetchTrigger: false }),

	// 검색 조건에서 선택된 금형 정보 (모달용)
	selectedMoldInfo: undefined,
	setSelectedMoldInfo: (moldInfo) => set({ selectedMoldInfo: moldInfo }),

	// ====== BOM 리스트 및 선택/편집 ======
	EQM4010_R01DetailList: [],
	setEQM4010_R01DetailList: (bomList: EQM4010_R01DetailDto[]) => set((state) => {
		let newList: EQM4010_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		bomList.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				...defaultEQM4010_R01DetailDto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			EQM4010_R01DetailList: newList
		}
	}),
	insertEQM4010_R01DetailList: (data: EQM4010_R01DetailDto[], index?: number) => set((state) => {
		let newEQM4010_R01DetailList = [...state.EQM4010_R01DetailList];

		let targetRowData = newEQM4010_R01DetailList.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...newEQM4010_R01DetailList.map(item => item.valueIndex || 0)) + 1;

		// newEQM4010_R01DetailList에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newEQM4010_R01DetailList.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newEQM4010_R01DetailList에 대체
		newEQM4010_R01DetailList = newEQM4010_R01DetailList.filter(item => item.orderIndex !== targetOrderIndex);
		newEQM4010_R01DetailList.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultEQM4010_R01DetailDto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		if (index !== undefined) {
			newEQM4010_R01DetailList.splice(index, 0, ...newData);
		} else {
			newEQM4010_R01DetailList.push(...newData);
		}
		
		return {
			...state,
			EQM4010_R01DetailList: newEQM4010_R01DetailList
		}
	}),

	removeEQM4010_R01Detail: (index: number) => set((state) => {
		const newEQM4010_R01DetailList = [...state.EQM4010_R01DetailList].filter((item) => item.valueIndex !== index);
		return {
			...state,
			EQM4010_R01DetailList: newEQM4010_R01DetailList
		}
	}),
	updateEQM4010_R01Detail: (index: number, updatedRow: EQM4010_R01DetailDto) => set((state) => {
		const _EQM4010_R01DetailList = state.EQM4010_R01DetailList.map(item =>
			item.valueIndex === index ? updatedRow : item
		);
		// if(updatedRow.bomSeq < 1) {
		// 	showWarning('순서는 1보다 작을 수 없습니다.');
		// 	updatedRow.bomSeq = 1;
		// }
		if(updatedRow.shotCount < 0) {
			showWarning('세척시타수는 0보다 작을 수 없습니다.');
			updatedRow.shotCount = 0;
		}
		if(updatedRow.nextCleanShot < 0) {
			showWarning('다음세척타수는 0보다 작을 수 없습니다.');
			updatedRow.nextCleanShot = 0;
		}
		return {
			...state,
			EQM4010_R01DetailList: _EQM4010_R01DetailList
		}
	}),

	selectedEQM4010_R01Detail: undefined,
	setSelectedEQM4010_R01Detail: (data: EQM4010_R01DetailDto | undefined) => set((state) => {
		return { selectedEQM4010_R01Detail: data, editEQM4010_R01Detail: data ? { ...data } : null };
	}),
	initSelectedEQM4010_R01Detail: () => set({ selectedEQM4010_R01Detail: undefined }),

	// ====== BOM 상세 행 삭제 관리 ======
	deletedEQM4010_R01DetailList: [],
	addDeletedEQM4010_R01DetailList: (idList: string[]) => set((state) => {
		const _deletedBomDetailList = [...state.deletedEQM4010_R01DetailList];
		for(const valueIndex of idList) {
			const isInserted = state.EQM4010_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.EQM4010_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedBomDetailList.push(valueIndex);
			}
		}
		return { ...state, deletedEQM4010_R01DetailList: _deletedBomDetailList };
	}),
	removeDeletedEQM4010_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		deletedEQM4010_R01DetailList: state.deletedEQM4010_R01DetailList.filter(value => idList ? !idList.includes(value) : false),
	})),

	// ====== BOM 상세 행 선택 관리 ======  
	selectedEQM4010_R01DetailList: [],
	setSelectedEQM4010_R01DetailList: (idList: string[]) => set({ selectedEQM4010_R01DetailList: idList }),
	addSelectedEQM4010_R01DetailList: (idList: string[]) => set((state) => {
		const _selectedEQM4010_R01DetailList = [...state.selectedEQM4010_R01DetailList];
		if(idList.length > 0) {
			_selectedEQM4010_R01DetailList.push(...idList);
		}
		return {
			...state,
			selectedEQM4010_R01DetailList: _selectedEQM4010_R01DetailList
		}
	}),
	removeSelectedEQM4010_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		selectedEQM4010_R01DetailList: state.selectedEQM4010_R01DetailList.filter(value => idList ? !idList.includes(value) : false),
	})),
	initSelectedEQM4010_R01DetailList: () => set({ selectedEQM4010_R01DetailList: [] }),
	allSelectedEQM4010_R01DetailList: () => set((state) => {
		const _selectedEQM4010_R01DetailList = [...state.EQM4010_R01DetailList.map(item => item.valueIndex.toString())];
		return {
			...state,
			selectedEQM4010_R01DetailList: _selectedEQM4010_R01DetailList
		}
	}),

	// ====== 컬럼 상태(그리드) ======
	columnState: null,				setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),
	detailColumnState: null,			setDetailColumnState: (state: ColumnState[] | null) => set({ detailColumnState: state }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),
	detailScrollTop: null,
	setDetailScrollTop: (top: number | null) => set({ detailScrollTop: top }),

	originalEQM4010_R01DetailList: [],
	setOriginalEQM4010_R01DetailList: (list: EQM4010_R01DetailDto[]) => set((state) => {
		let newList: EQM4010_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		list.forEach((item, index) => {
			newList.push({ 
				...defaultEQM4010_R01DetailDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalEQM4010_R01DetailList: newList
		}
	}),

	// ====== 초기화 ======
	allCount: 0,
	setAllCount: (allCount: number) => set({ allCount }),

	detailFetchTrigger: false,
	setDetailFetchTrigger: (trigger: boolean) => set({ detailFetchTrigger: trigger }),
	

	initData: () => set(() => ({
		EQM4010_R01Filter: defaultEQM4010_R01Filter,
		EQM4010_R01PastFilter: defaultEQM4010_R01Filter,
		EQM4010_R01List: [],
		selectedEQM4010_R01: undefined,
		selectedMoldInfo: undefined,
		EQM4010_R01DetailList: [],
		selectedEQM4010_R01Detail: undefined,
		editEQM4010_R01Detail: null,
		deletedEQM4010_R01DetailList: [],
		selectedEQM4010_R01DetailList: [],
		columnState: null,
		detailColumnState: null,
		allCount: 0,

		detailFetchTrigger: false,
		scrollTop: null,
		detailScrollTop: null,

		EQM4010_R01GridCalendarState: {
			pickerVisible: false,
			pickerPosition: { top: 0, left: 0 },
			targetRowIndex: null,
			targetField: null,
			targetDate: undefined
		}
	})),
})); 


export const useEQM4010_R01Store_GridCalendar = create<Store_EQM4010_R01_GridCalendarState>((set) => ({

	// ====== GridCalendar 상태 ======
	EQM4010_R01GridCalendarState: {
		pickerVisible: false,
		pickerPosition: { top: 0, left: 0 },
		targetRowIndex: null,
		targetField: null,
		targetDate: undefined
	},
	setEQM4010_R01GridCalendarState: (newState: Partial<Store_EQM4010_R01_GridCalendarState['EQM4010_R01GridCalendarState']>) => set((state) => ({
		...state,
		EQM4010_R01GridCalendarState: { ...state.EQM4010_R01GridCalendarState, ...newState }
	})),
	initEQM4010_R01GridCalendarState: () => set((state) => ({
		...state,
		EQM4010_R01GridCalendarState: {
			pickerVisible: false,
			pickerPosition: { top: 0, left: 0 },
			targetRowIndex: null,
			targetField: null,
			targetDate: undefined
		}
	})),


})); 